import { SupportedLanguages } from "../common/controls/lang-switcher";
import { localesKeys__SkillsChart } from "../common/skills-chart/locales";
import { localesKeys__PositionBlock } from "../modules/full-cv/position-block-locales";
import { localesKeys__VisibilityToggles } from "../modules/full-cv/visibility-toggles-locales";
import { localesKeys__Interview } from "../modules/interview/locales";
import { localesKeys__MiniCv } from "../modules/mini-cv/locales";
import { localesKeys__ContactPage } from "../pages/contact/locales";
import { localesKeys__RightSwitcher } from "../modules/sunday-top-nav/buttons/right-toggle/locales";
import { localesKeys__TopNavStats } from "../modules/sunday-top-nav/locales";
import { localesKeys__UserButton } from "../modules/sunday-top-nav/buttons/user-button/locales";
import { localesKeys__Navigation } from "../routes/locales";
import { localesKeys__Analytics } from "../analytics/locales";

export const USER_LANG_KEY: string = 'volobuev-cv-site-locale';

export type ILanguageDictionary = {
  [language in SupportedLanguages]: MergeTranslateKeys;
};

export type TranslatedKey = keyof MergeTranslateKeys;

export type MergeTranslateKeys = localesKeys__SkillsChart
& localesKeys__RightSwitcher
& localesKeys__UserButton
& localesKeys__Navigation
& localesKeys__VisibilityToggles
& localesKeys__PositionBlock
& localesKeys__Interview
& localesKeys__ContactPage
& localesKeys__MiniCv
& localesKeys__TopNavStats
& localesKeys__Analytics
& {
  cardAbout_label: string;
  footerNoTracking__label: string;
};